var _ = require("../uam/fields.module.js")(module.exports, {
    namespace: "time",
    title: "Accounting Time",
    description: "Time in HHMMSS format (24hr), stored as a string.",
    type: "field",
    use: {
        namespace: "ua.input"
    },
    fields: {
        min: {
            title: "Minimum Time",
            type: "string"
        },
        max: {
            title: "Maximum Time",
            type: "string"
        }
    },
    tests: {
        valid: {
            must: true,
            run: function () {
                return validate({ min: "070000", max: "200000" }, "152105");
            }
        },
        tooEarly: {
            throw: "fields.time.outOfRange",
            run: function () {
                return validate({ min: "080000" }, "070000");
            }
        },
        tooLate: {
            throw: "fields.time.outOfRange",
            run: function () {
                return validate({ max: "180000" }, "190000");
            }
        },
        invalid: {
            throw: "fields.time.invalid",
            run: function () {
                return validate({}, "9:30PM");
            }
        }
    },
    errors: {
        invalid: {
            title: "Invalid Time",
            description: "Time must be in HHMMSS (or HHMM) 24hr format.",
            template: "Invalid time '${value}'"
        },
        outOfRange: {
            title: "Time Out of Range",
            description: "Time must be between specified min and max.",
            template: "Time '${value}' is not between ${min} and ${max}"
        }
    }
});

function validate(spec, value) {
    if (typeof value !== "string" || !/^[0-9]{4,6}$/.test(value)) {
        _.errors.invalid.throw({ value: value });
    }

    var padded = value.length === 4 ? value + "00" : value;

    if (spec.min && padded < spec.min) {
        _.errors.outOfRange.throw({ value: value, min: spec.min, max: spec.max });
    }

    if (spec.max && padded > spec.max) {
        _.errors.outOfRange.throw({ value: value, min: spec.min, max: spec.max });
    }
}
module.exports.validate = validate;
